// extracted by mini-css-extract-plugin
export default {"noteCard":"note_noteCard__L4OTU","cardBody":"note_cardBody__FkpuL","cardText":"note_cardText__N8H35"};